import React from "react";
import { Col, Row } from "antd";
import DescriptionCard from "./DescriptionCard";
function EdaDescription() {
  return (
    <div className="p-5">
      <Row>
        <Col lg={8}>
          <DescriptionCard />
        </Col>
      </Row>
    </div>
  );
}

export default EdaDescription;
